/**
 * Единая точка для Telegram-ссылок во фронте.
 * Домен t.me удалён из DNS-зоны .me реестром 14.07.2026 и не открывается в
 * браузерах. telegram.me — официально рекомендованная замена (те же форматы:
 * /username, /c/id, /+hash, /bot?start=). Значение берётся из env (build-time),
 * чтобы переключать без правки кода.
 */
export const TELEGRAM_DOMAIN = import.meta.env.VITE_TELEGRAM_DOMAIN || 'telegram.me'

/** Сборка Telegram-ссылки: telegramUrl('user?start=1') → https://telegram.me/user?start=1 */
export const telegramUrl = (path = ''): string => `https://${TELEGRAM_DOMAIN}/${path.replace(/^\/+/, '')}`
